export const alwaysVisibleDealAttributes = [
    'vehicle.vin',
    'vehicle.inventoryType',
    'vehicle.odometer',
    'finance.dealType',
    'finance.term',
    'finance.apr',
    'finance.customerState',
    'finance.isBusinessCustomer'
];
